export default __webpack_public_path__ + "static/media/4-cheese.71e12936.jpg";